import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	for: {
		id: 'search-page.atlas.for',
		defaultMessage: 'for',
		description: 'The conjunction between a status and date e.g. "On track for August"',
	},
});
